var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2C14.3856 1.78113 14.6454 1.60752 14.9314 1.48906C15.2173 1.37061 15.5238 1.30965 15.8334 1.30965C16.1429 1.30965 16.4494 1.37061 16.7353 1.48906C17.0213 1.60752 17.2812 1.78113 17.5 2C17.7189 2.21887 17.8925 2.47871 18.011 2.76468C18.1294 3.05064 18.1904 3.35714 18.1904 3.66667C18.1904 3.9762 18.1294 4.2827 18.011 4.56866C17.8925 4.85463 17.7189 5.11447 17.5 5.33334L6.25002 16.5833L1.66669 17.8333L2.91669 13.25L14.1667 2Z",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.155bb63d68c1363bd7774f291ce5b3c7.svg";
export { ForwardRef as ReactComponent };